// extracted by mini-css-extract-plugin
module.exports = {"icon":"TooltipBasicIcon-module__icon--3KF1t","iconSecondary":"TooltipBasicIcon-module__iconSecondary--1guD2"};